import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance25nhr3t715wdo as CLASS_getInstance,
  OBJECT_getInstance167untwb9admi as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstance39dg6hx0yqfbs as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb as access$checkEncodingConflicts$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { switchMode35g725ikhjpwv as switchMode } from './WriteMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded1h6zoomba5tnf as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstance1339zuieiizg3 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance2ln0tj1crqgxz as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance2utgi65n0nnqj as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance3rx8u2n07bmtm as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.o2t_1.r2r();
  $this.w1s(discriminator);
  $this.o2t_1.u2r(_Char___init__impl__6a9atx(58));
  $this.o2t_1.t2r();
  $this.w1s(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static h2v(composer, json, mode, modeReuseCache) {
        var $this = this.k1s();
        $this.o2t_1 = composer;
        $this.p2t_1 = json;
        $this.q2t_1 = mode;
        $this.r2t_1 = modeReuseCache;
        $this.s2t_1 = $this.p2t_1.g1s();
        $this.t2t_1 = $this.p2t_1.t2m_1;
        $this.u2t_1 = false;
        $this.v2t_1 = null;
        $this.w2t_1 = null;
        var i = $this.q2t_1.w1_1;
        if (!($this.r2t_1 == null)) {
          if (!($this.r2t_1[i] === null) || !($this.r2t_1[i] === $this)) {
            $this.r2t_1[i] = $this;
          }
        }
        return $this;
      }
      y2o() {
        return this.p2t_1;
      }
      static x2t(output, json, mode, modeReuseCache) {
        return this.h2v(Composer(output, json), json, mode, modeReuseCache);
      }
      g1s() {
        return this.s2t_1;
      }
      p1t(descriptor, index) {
        return this.t2t_1.g2o_1;
      }
      k1t(serializer, value) {
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
          if (this.y2o().t2m_1.o2o_1) {
            serializer.b1n(this, value);
            break $l$block;
          }
          var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
          var tmp;
          if (isPolymorphicSerializer) {
            tmp = !this.y2o().t2m_1.w2o_1.equals(ClassDiscriminatorMode_NONE_getInstance());
          } else {
            var tmp_0;
            switch (this.y2o().t2m_1.w2o_1.w1_1) {
              case 0:
              case 2:
                tmp_0 = false;
                break;
              case 1:
                // Inline function 'kotlin.let' call

                var it = serializer.a1n().w1p();
                tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_0;
          }
          var needDiscriminator = tmp;
          var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.a1n(), this.y2o()) : null;
          var tmp_1;
          if (isPolymorphicSerializer) {
            var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (value == null) {
                var message = 'Value for serializer ' + toString_0(serializer.a1n()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                throw IllegalArgumentException().n2(toString_0(message));
              } else {
                break $l$block_0;
              }
            }
            var actual = findPolymorphicSerializer(casted, this, value);
            tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
          } else {
            tmp_1 = serializer;
          }
          var actualSerializer = tmp_1;
          if (!(baseClassDiscriminator == null)) {
            access$checkEncodingConflicts$tPolymorphicKt(this.y2o(), serializer, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.a1n().w1p());
            var serialName = actualSerializer.a1n().d1o();
            this.v2t_1 = baseClassDiscriminator;
            this.w2t_1 = serialName;
          }
          actualSerializer.b1n(this, value);
        }
      }
      r1r(descriptor) {
        var newMode = switchMode(this.p2t_1, descriptor);
        if (!(newMode.a2v_1 === _Char___init__impl__6a9atx(0))) {
          this.o2t_1.u2r(newMode.a2v_1);
          this.o2t_1.p2r();
        }
        var discriminator = this.v2t_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.w2t_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.d1o() : tmp0_elvis_lhs);
          this.v2t_1 = null;
          this.w2t_1 = null;
        }
        if (this.q2t_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.r2t_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.w1_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().h2v(this.o2t_1, this.p2t_1, newMode, this.r2t_1) : tmp2_elvis_lhs;
      }
      s1r(descriptor) {
        if (!(this.q2t_1.b2v_1 === _Char___init__impl__6a9atx(0))) {
          this.o2t_1.q2r();
          this.o2t_1.s2r();
          this.o2t_1.u2r(this.q2t_1.b2v_1);
        }
      }
      l1s(descriptor, index) {
        switch (this.q2t_1.w1_1) {
          case 1:
            if (!this.o2t_1.o2r_1) {
              this.o2t_1.u2r(_Char___init__impl__6a9atx(44));
            }

            this.o2t_1.r2r();
            break;
          case 2:
            if (!this.o2t_1.o2r_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.o2t_1.u2r(_Char___init__impl__6a9atx(44));
                this.o2t_1.r2r();
                tmp_0 = true;
              } else {
                this.o2t_1.u2r(_Char___init__impl__6a9atx(58));
                this.o2t_1.t2r();
                tmp_0 = false;
              }
              tmp.u2t_1 = tmp_0;
            } else {
              this.u2t_1 = true;
              this.o2t_1.r2r();
            }

            break;
          case 3:
            if (index === 0)
              this.u2t_1 = true;
            if (index === 1) {
              this.o2t_1.u2r(_Char___init__impl__6a9atx(44));
              this.o2t_1.t2r();
              this.u2t_1 = false;
            }

            break;
          default:
            if (!this.o2t_1.o2r_1) {
              this.o2t_1.u2r(_Char___init__impl__6a9atx(44));
            }

            this.o2t_1.r2r();
            this.w1s(getJsonElementName(descriptor, this.p2t_1, index));
            this.o2t_1.u2r(_Char___init__impl__6a9atx(58));
            this.o2t_1.t2r();
            break;
        }
        return true;
      }
      l1t(descriptor, index, serializer, value) {
        if (!(value == null) || this.t2t_1.l2o_1) {
          super.l1t(descriptor, index, serializer, value);
        }
      }
      y1s(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.o2t_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.o2t_1;
          } else {
            var tmp0 = this.o2t_1.n2r_1;
            var p1 = this.u2t_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$0 = tmp_0;
          tmp = StreamingJsonEncoder().h2v(tmp$ret$0, this.p2t_1, this.q2t_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.o2t_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.o2t_1;
          } else {
            var tmp0_0 = this.o2t_1.n2r_1;
            var p1_0 = this.u2t_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$2 = tmp_2;
          tmp = StreamingJsonEncoder().h2v(tmp$ret$2, this.p2t_1, this.q2t_1, null);
        } else if (!(this.v2t_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.w2t_1 = descriptor.d1o();
          tmp = this;
        } else {
          tmp = super.y1s(descriptor);
        }
        return tmp;
      }
      n1s() {
        this.o2t_1.w2r('null');
      }
      o1s(value) {
        if (this.u2t_1) {
          this.w1s(value.toString());
        } else {
          this.o2t_1.f2s(value);
        }
      }
      p1s(value) {
        if (this.u2t_1) {
          this.w1s(value.toString());
        } else {
          this.o2t_1.a2s(value);
        }
      }
      q1s(value) {
        if (this.u2t_1) {
          this.w1s(value.toString());
        } else {
          this.o2t_1.c2s(value);
        }
      }
      r1s(value) {
        if (this.u2t_1) {
          this.w1s(value.toString());
        } else {
          this.o2t_1.d2s(value);
        }
      }
      s1s(value) {
        if (this.u2t_1) {
          this.w1s(value.toString());
        } else {
          this.o2t_1.e2s(value);
        }
      }
      t1s(value) {
        if (this.u2t_1) {
          this.w1s(value.toString());
        } else {
          this.o2t_1.y2r(value);
        }
        if (!this.t2t_1.q2o_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      u1s(value) {
        if (this.u2t_1) {
          this.w1s(value.toString());
        } else {
          this.o2t_1.z2r(value);
        }
        if (!this.t2t_1.q2o_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      v1s(value) {
        this.w1s(toString(value));
      }
      w1s(value) {
        return this.o2t_1.g2s(value);
      }
      x1s(enumDescriptor, index) {
        this.w1s(enumDescriptor.a1q(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.x1p() && get_unsignedNumberDescriptors().t2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.x1p() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).a1n(), serializer_0(Companion_getInstance_0()).a1n(), serializer_1(Companion_getInstance_1()).a1n(), serializer_2(Companion_getInstance_2()).a1n()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
